import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  HeaderMenuItemComponent,
  MenuItemType,
  SelectItem,
} from '../header-menu-item/header-menu-item.component';
import { CommonModule } from '@angular/common';
import { OverlayBackdropComponent } from '../overlay-backdrop/overlay-backdrop.component';
import { IconModule } from '@rogers/cdk/icon';
import { ButtonModule } from '@rogers/cdk/button';

export interface MenuItem {
  menuItemText: string;
  menuItemLabel: string;
  menuItemKey: string;
  menuItemType: MenuItemType;
  menuItemOptions: SelectItem[];
  selectedMenuItemOption;
  isMenuItemVisible: boolean;
}

@Component({
  standalone: true,
  selector: 'ucx-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    HeaderMenuItemComponent,
    OverlayBackdropComponent,
    IconModule,
    ButtonModule,
  ],
})
export class HeaderComponent implements AfterViewInit {
  @Input() logo: string | null = '';
  @Input() isLiveChat: boolean | null = false;
  @Input() headerTitle = 'Title';
  @Input() settingsTitle = 'Settings';
  @Input() minimizeTitle = 'Minimize';
  @Input() closeTitle = 'Close';
  @Input() headerBackgroundImage: string | null = '';
  @Input() headerBackgroundColor: string | null = '';
  @Input() menuItems: MenuItem[];
  @Input() version: string | null = '';

  @Input() onMinimizeChat;
  @Input() onCloseChat;
  @Input() onMenuItemChanged;

  @ViewChild('headerDiv') headerDiv: ElementRef | undefined;

  isMenuOpen = false;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.registerClickOutsideEvent();
  }

  registerClickOutsideEvent(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      /**
       * Only run when click outside the header div
       */
      if (
        this.headerDiv &&
        !this.headerDiv.nativeElement.contains(e && e.target)
      ) {
        // clicked outside => close dropdown list
        this.closeMenu();
      }
    });
  }

  onMinimize(): void {
    this.closeMenu();
    this.onMinimizeChat();
  }

  onClose(): void {
    this.closeMenu();
    this.onCloseChat();
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  onSelectMenuItem(event): void {
    this.onMenuItemChanged(event);
  }

  getHeaderStyles(): string {
    return this.headerBackgroundColor
      ? `background-color: ${this.headerBackgroundColor}`
      : this.headerBackgroundImage
      ? `background-image: url( ${this.headerBackgroundImage} )`
      : '';
  }
}
